<template>
    <v-tab-item :value="tabValue">
            <v-layout column justify-center align-center>
                <v-card-title class="font-size-26 font-size-md-30 font-size-lg-36 mb-md-20 mb-10">미팅 일정 선택</v-card-title>
                <v-card-subtitle class="page-text--lg grey-6--text pb-20 pb-md-40">미팅이 가능한 시간을 선택해주세요</v-card-subtitle>
                <div class="w-100 scroll-primary pr-10" style="overflow-y: auto;" :style="$vuetify.breakpoint.mdAndUp ? 'max-height: 460px;' : 'max-height: 320px;'">
                    <v-card-text class="d-flex flex-column" style="position: relative; flex: 0 1 auto; overflow-y: hidden">
                        <meeting-schedules-card mode="form" v-bind="{ value, meeting }" @input="(value) => $emit('input', value)" />
                    </v-card-text>                        
                </div>
                <div class="v-btn-group">
                    <!-- <v-btn outlined @click="$emit('prev')"> 이전으로</v-btn> -->
                    <v-btn v-bind="{ disabled, loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('save')"><span>{{ saveText }}</span></v-btn>
                </div>
            </v-layout>
    </v-tab-item>
</template>

<script>
import { initMeeting, initMeetingSchedule } from "@/assets/variables";

import MeetingSchedulesCard from "@/components/dumb/meeting-schedules-card.vue";

export default {
    components: {
        MeetingSchedulesCard,
    },
    props: {
        value: { type: String }, // date
        loading: { type: Boolean, default: false },
        meeting: { type: Object, default: initMeeting },
        schedule: { type: Object, default: initMeetingSchedule },
        tabValue: { type: String },
    },
    computed: {
        disabled() {
            return !this.value;
        },
        saveText() {
            return this.schedule?._id ? "변경하기" : "선택하기";
        },
    },
};
</script>

<style></style>
